export default "__VITE_ASSET__CtD5j0Gp__"